<script setup>
import { computed } from 'vue'

const props = defineProps({
  context: {
    type: Object,
    required: true,
  },
})

const value = computed({
  get: () => props.context._value,
  set: (value) => props.context.node.input(value),
})

const store = useLandlordStore()

const landlords = computed(() => store.landlords)

onMounted(() => {
  if (store.landlords.length === 0) {
    store.fetchLandlords()
  }
})
</script>

<template>
  <div>
    <el-select v-model="value">
      <el-option v-for="(landlord, index) in landlords" :key="index" :label="landlord.name" :value="landlord.landlord_corr"></el-option>
    </el-select>
  </div>
</template>

<style scoped></style>
